import api from "@/lib/api";
import { track } from "@/lib/track";

// Starts a Stripe checkout for the given lookup_key and redirects to Stripe.
// userId ties the payment to the parent account so it can be marked subscribed.
export async function startCheckout(lookupKey, userId) {
  track("subscribe_click", { lookup_key: lookupKey });
  const { data } = await api.post("/payments/checkout", {
    lookup_key: lookupKey,
    origin_url: window.location.origin,
    user_id: userId || null,
  });
  if (data.checkout_url) window.location.href = data.checkout_url;
}

// Opens the Stripe customer portal (update card / switch plan / cancel).
export async function startPortal() {
  track("billing_portal_click", {});
  const { data } = await api.post("/payments/portal", { origin_url: window.location.origin });
  if (data.portal_url) window.location.href = data.portal_url;
}
